/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './CloseButton.style';
import CrossIcon from 'src/shared/ui/component/icon/CrossIcon';

type Props = {
  small?: boolean,
  layoutClass?: string,
  forceBlur?: boolean,
  isTrimmed?: boolean,
  tabIndex?: number,
  handleClick: () => void,
};

const useStyles = createUseStyles(styles);

const CloseButton = ({
  small,
  layoutClass,
  isTrimmed,
  tabIndex,
  handleClick,
  forceBlur,
}: Props): React.Node => {
  const extraProps = {};

  if (typeof tabIndex === 'number') {
    extraProps.tabIndex = tabIndex;
  }

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onClick = (e: MouseEvent) => {
    e.preventDefault();

    handleClick();

    if (forceBlur) {
      const { current: rootElt } = rootRef;

      if (rootElt) {
        rootElt.blur();
      }
    }
  };

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-isTrimmed']]: isTrimmed,
  });

  /*
   |----------------------------------------------------------------------------
   | Refs
   |----------------------------------------------------------------------------
   */

  const rootRef = React.createRef();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const iconElt = small ? <CrossIcon /> : <CrossIcon large />;

  return (
    <a
      className={rootClasses}
      href="#"
      onClick={onClick}
      ref={rootRef}
      {...extraProps}
    >
      {iconElt}
    </a>
  );
};

export default compose(React.memo)(CloseButton);
